import cls from 'classnames';
import React, { PureComponent } from 'react';

import { POLLS_QUESTION_IMAGE } from '../../dataHooks';
import { POLLS_QUESTION_TEXT_INPUT } from '../../dataHooks';
import { ImageUpload } from '../image-upload';
import { PollContextPropTypes, withPoll } from '../poll-context';
import { RCEHelpersPropTypes, withRCEHelpers } from '../rce-helpers-context';
import { TextField } from '../text-field';
import styles from './poll-header.scss';

class PollHeaderComponent extends PureComponent {
  render() {
    const { poll, changePollTitle, changePollImage, layout, t, rce } = this.props;

    return (
      <div
        className={cls(styles.header, {
          [styles.webview]: rce.isWebView,
        })}
      >
        <TextField
          autofocus
          textAutoResize
          maxLength={160}
          className={styles.title}
          value={poll.title}
          onChange={changePollTitle}
          placeholder={t('Poll_Editor_Question_Placeholder')}
          dataHook={POLLS_QUESTION_TEXT_INPUT}
        />
        {layout.poll?.enableImage && (
          <ImageUpload
            dataHook={POLLS_QUESTION_IMAGE}
            disabled={rce.isPreview}
            className={styles.image}
            value={poll.image?.src?.url}
            onChange={changePollImage}
          />
        )}
      </div>
    );
  }
}

export const PollHeader = withRCEHelpers(withPoll(PollHeaderComponent));

PollHeaderComponent.propTypes = {
  ...PollContextPropTypes,
  ...RCEHelpersPropTypes,
};
